import { appConfig } from '@/config/app-config';
import axios from 'axios';

export default class BCApiDebugInterceptor {
  constructor() {
    axios.interceptors.request.use(
      function(config) {
        if (appConfig.debugConfig.activateXDebug) {
          config.params = {
            ...config.params,
            XDEBUG_SESSION: appConfig.debugConfig.xdebugSession,
          };
        }
        return config;
      },
      function(err) {
        return Promise.reject(err);
      },
    );
  }
}
